import i18next, { use as i18nSetup } from "i18next";
import { locales } from "./locales";
import { initReactI18next } from "react-i18next";

export type Locale = keyof typeof locales;

i18nSetup(initReactI18next).init({
  fallbackLng: "en",
  resources: locales,
  saveMissing: true,
  missingKeyHandler: function (lngs, ns, key) {
    const errorMessage = `Missing translation for key: ${key}`;
    if (["test", "development"].includes(process.env.NODE_ENV || "")) {
      throw Error(errorMessage);
    } else {
      console.error(errorMessage);
    }
  },
});

export { i18next as i18n };
